// import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaInstagram, FaFacebookF, FaTwitter, FaLinkedinIn } from "react-icons/fa";
import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import logo from "../../images/footer/footerLogo.png";
import logo from "../../images/footer/carzenFlogo.png";
import link from "../../images/footer/c_link.png";
import twt from "../../images/footer/c_twt.png";
import face from "../../images/footer/c_facebook.png";
import insta from "../../images/footer/ins.png";
import phone from "../../images/footer/c_phone.png";
import locationpng from "../../images/footer/c_location.png";
import message from "../../images/footer/c_message.png";
import ytlogo from "../../images/footer/yt_logo.png";
export default function Footer() {
  const location = useLocation();
  const navigate = useNavigate();

  const moveToSection = (id) => {
    if (id === "home") {
      // Go to ABOUT page
      navigate("/", { state: { scrollTo: id } });

      return;
    }
    if (id === "contact us") {
      // Go to ABOUT page
      navigate("/", { state: { scrollTo: id } });

      return;
    }
    if (id === "about") {
      // Go to ABOUT page
      navigate("/about_us", { state: { scrollTo: id } });
      return;
    }
    if (id === "services") {
      // Go to ABOUT page
      navigate("/", { state: { scrollTo: id } });

      return;
    }
    if (id === "prices") {
      // Go to ABOUT page
      navigate("/", { state: { scrollTo: id } });

      return;
    }

    // if (location.pathname !== "/") {
    //   // Go to home page *with state*
    //   navigate("/", { state: { scrollTo: id } });
    // }
    //  else if (location.pathname !== "/about") {
    //   navigate("/about", { state: { scrollTo: id } });
    // }
    else {
      // Already on home → scroll immediately
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };
  useEffect(() => {
    if (location.state?.scrollTo) {
      const id = location.state.scrollTo;
      const element = document.getElementById(id);

      setTimeout(() => {
        element?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 200);
    }
  }, [location]);
  return (
    <footer className="bg-gradient-to-t from-[#CCA065]/30 to-white/100  max-w-8xl md:px-[50px] lg:px-[120px] mt-2 md:mt-20  text-gray-700 md:pt-12 md:pb-6 px-4 ">
      <div className=" grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 md:gap-4 lg:gap-0">
        {/* Company Info */}
        <div className="mb-3 md:mb-0">
          <div className="flex items-center  mb-3">
            <div className=" py-1 ">
              <img
                src={logo}
                className="w-full h-10  object-fill"
                alt="cargen logo"
              />
            </div>
            {/* <span className="font-semibold text-gray-900 tracking-wide">
              CARZEN LOGISTICS
            </span> */}
          </div>
          <p className="text-sm mb-4 md:text-[16px] text-[#808080] lg:leading-7">
            Carzen Logistics delivers reliable, tech-enabled corporate travel
            with 24/7 support. Smooth, safe, and on-time journeys — every day.
          </p>

          <div className="space-y-3 lg:mt-9 text-sm md:text-[16px]">
            <div className="flex items-start space-x-2 text-[#808080]">
              <img
                src={phone}
                className="w-5 h-5 md:w-[20px] md:h-[20px] object-contain"
                alt="phone"
              />
              {/* <FaPhoneAlt className="text-gray-600" /> */}
              <span className="text-[#808080] lg:mb-4">+91 8123415558</span>
            </div>
            <Link
              to="https://mail.google.com/mail/?view=cm&fs=1&to=carzenlogistics@gmail.com&su=Corporate%20Car%20Service%20Requirement"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-start space-x-2"
            >
              <img
                src={message}
                className="w-5 h-5 md:w-[20px] md:h-[20px]"
                alt="email"
              />

              <span className="text-[#808080] lg:mb-4">
                carzenlogistics@gmail.com
              </span>
            </Link>
            <div className="flex items-start space-x-2">
              {/* <FaMapMarkerAlt className="text-gray-600" /> */}
              <img
                src={locationpng}
                className="w-5 h-5 md:w-[20px] md:h-[20px]"
                alt="location"
              />
              <span className="text-[#808080]">Bengaluru, Karnataka</span>
            </div>
          </div>
        </div>

        {/* Menu */}
        <div className=" lg:ml-32">
          <h3 className="font-semibold text-gray-900  mt-4 md:mt-0 mb-3">
            Menu
          </h3>
          <ul className="space-y-2 md:space-y-4 text-sm md:text-[16px] text-[#808080]">
            <li onClick={() => moveToSection("Home")}>
              <p href="#" className="hover:text-gray-900">
                Home
              </p>
            </li>
            <li onClick={() => moveToSection("services")}>
              <p className="hover:text-gray-900">Services</p>
            </li>
            <li onClick={() => moveToSection("prices")}>
              <p className="hover:text-gray-900">Prices</p>
            </li>
            <li onClick={() => moveToSection("about")}>
              <p href="#" className="hover:text-gray-900">
                About
              </p>
            </li>
          </ul>
        </div>

        {/* Services */}
        <div className="lg:ml-12">
          <h3 className="font-semibold text-gray-900   mt-4 md:mt-0 mb-3">
            Services
          </h3>
          <ul className="space-y-2 md:space-y-4 text-sm md:text-[16px]  text-[#808080]">
            <li onClick={() => moveToSection("services")}>
              <p href="#" className="hover:text-gray-900">
                Employee Transportation
              </p>
            </li>
            <li onClick={() => moveToSection("services")}>
              <p href="#" className="hover:text-gray-900">
                Airport Transfers
              </p>
            </li>
            <li onClick={() => moveToSection("services")}>
              <p href="#" className="hover:text-gray-900">
                Outstation Business Trips
              </p>
            </li>
            <li onClick={() => moveToSection("services")}>
              <p href="#" className="hover:text-gray-900">
                Event & Conference Transport
              </p>
            </li>
          </ul>
        </div>

        {/* Legal */}
        <div className="md:ml-0 lg:ml-20">
          <h3 className="font-semibold text-gray-900 mt-4 md:mt-0  mb-3">
            Legal
          </h3>
          <ul className="space-y-2 md:space-y-4 text-sm  text-[#808080]">
            <li>
              <Link to="/privacy-policy" className="hover:text-gray-900">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/terms&conditions" className="hover:text-gray-900">
                Terms & Conditions
              </Link>
            </li>
          </ul>
          {/* Social Icons */}
          <div className="flex w-full text-center gap-8 md:gap-0 lg:gap-5 mt-6 lg:mt-40 text-gray-800">
            <Link
              to="https://www.instagram.com/carzenlogistics/?igsh=MW4zbjEwYmQ1NzN6MA%3D%3D#"
              target="_blank"
              className="hover:text-gray-600"
            >
              <img
                src={insta}
                className="w-5 h-5 object-contain"
                alt="instagram"
              />
              {/* <FaTwitter /> */}
            </Link>
            <Link
              to="https://www.youtube.com/channel/UCfDQNn36N_n7QTITHMmvyMA"
              target="_blank"
              className="hover:text-gray-600"
            >
              <img
                src={ytlogo}
                className="w-5 h-5 object-contain"
                alt="facebook"
              />
              {/* <FaLinkedinIn /> */}
            </Link>
            <Link href="#" className="hover:text-gray-600">
              <img
                src={link}
                className="w-5 h-5 object-contain"
                alt="linkedIn"
              />
            </Link>
            <Link href="#" className="hover:text-gray-600">
              <img src={twt} className="w-5 h-5 object-contain" alt="twitter" />
            </Link>

            <Link href="#" className="hover:text-gray-600">
              <img
                src={face}
                className="w-5 h-5 object-contain"
                alt="facebook"
              />
            </Link>
          </div>
        </div>
      </div>

      <div className="flex flex-col  md:flex-row w-full justify-between text-center gap-1 md:gap-3 font-medium mt-6  lg:mt-14 text-[#666666]">
        <p className="text-start  md:text-center text-[12px] md:text-[16px] ">
          © {new Date().getFullYear()} Carzen Logistics — All Rights Reserved
        </p>

        {/* Footer Bottom */}
        <p className="text-start  mb-2 md:text-center text-[12px] md:text-[16px] ">
          <Link to="https://www.nestoricdigital.com" target="_blank">
            Designed & Developed by Nestoric Digital
          </Link>
        </p>
      </div>
    </footer>
  );
}
